

import img1 from '../images/product/product3.jpg'
import img2 from '../images/product/product44.jpg'
import img3 from '../images/product/product45.jpg'
import img4 from '../images/product/product46.jpg'
import img5 from '../images/product/product48.jpg'
import img6 from '../images/product/product49.jpg'
import img7 from '../images/product/product50.jpg'
import img8 from '../images/product/product47.jpg'
import avt from '../images/author/authorpd14.png'
import avt1 from '../images/author/authorpd14.png'
import avt2 from '../images/author/authorpd15.png'
import avt3 from '../images/author/authorpd16.png'
const dataExplore = [
    {
        id: 1,
        img: img1,
        avt: avt,
        title: 'Apple Gift Card',
        create: 'Apple Inc',
        price : '₹1500',
        avt1: avt1,
        avt2: avt2,
        avt3: avt3,
    },
    {
        id: 2,
        img: img2,
        avt: avt,
        title: 'Amazon Pay Gift Card',
        create: 'Amazon',
        price : '₹2000',
        avt1: avt1,
        avt2: avt2,
        avt3: avt3,
    },
    {
        id: 3,
        img: img3,
        avt: avt,
        title: 'Flipkart Gift Card',
        create: 'Flipkart',
        price : '₹1000',
        avt1: avt1,
        avt2: avt2,
        avt3: avt3,
    },
    {
        id: 4,
        img: img4,
        avt: avt,
        title: 'Swiggy Voucher',
        create: 'Swiggy',
        price : '₹1000',
        avt1: avt1,
        avt2: avt2,
        avt3: avt3,
    },
    {
        id: 5,
        img: img5,
        avt: avt,
        title: 'Myntra Gift Card',
        create: 'Myntra',
        price : '₹500',
        avt1: avt1,
        avt2: avt2,
        avt3: avt3,
    },
    {
        id: 6,
        img: img6,
        avt: avt,
        title: 'Myntra Gift Card',
        create: 'Myntra',
        price : '₹1000',
        avt1: avt1,
        avt2: avt2,
        avt3: avt3,
    },
    {
        id: 7,
        img: img7,
        avt: avt,
        title: 'Myntra Gift Card',
        create: 'Myntra',
        price : '₹2000',
        avt1: avt1,
        avt2: avt2,
        avt3: avt3,
    },
    {
        id: 8,
        img: img8,
        avt: avt,
        title: 'Swiggy Voucher',
        create: 'Swiggy',
        price : '₹900',
        avt1: avt1,
        avt2: avt2,
        avt3: avt3,
    },

   
]

export default dataExplore;